module.exports = __webpack_public_path__ + "static/img/mobilebanner.aee7ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilebanner.png
// module id = jQIP
// module chunks = 1